import { render, staticRenderFns } from "./etc-logo-transparent.vue?vue&type=template&id=14d7b5bc&"
var script = {}
import style0 from "./etc-logo-transparent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports